import { render, staticRenderFns } from "./design_order.vue?vue&type=template&id=0c88de41&scoped=true"
import script from "./design_order.vue?vue&type=script&lang=js"
export * from "./design_order.vue?vue&type=script&lang=js"
import style0 from "./design_order.vue?vue&type=style&index=0&id=0c88de41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88de41",
  null
  
)

export default component.exports